// extracted by mini-css-extract-plugin
export default {"imageWrapper":"rH-z","twoColumnImage":"sH-z"};